import React from "react";
import { Field } from "./Field";

export function toYouTubeEmbed(url) {
    if (!url) return "";
    const m = url.match(/(?:youtube\.com\/watch\?(?:.*&)?v=|youtu\.be\/|youtube\.com\/shorts\/|youtube\.com\/embed\/|youtube\.com\/v\/)([A-Za-z0-9_-]{6,})/);
    return m ? `https://www.youtube.com/embed/${m[1]}` : "";
}

export const VideoField = ({ value, onChange }) => {
    const embed = toYouTubeEmbed(value);
    return (
        <Field label="YouTube URL (Required)">
            <input data-testid="editor-video" required value={value}
                onChange={(e) => onChange(e.target.value)} className="tz-input"
                placeholder="Paste any YouTube link: watch, youtu.be, shorts, or embed" />
            <p className="text-xs text-zinc-500 mt-2 font-mono uppercase tracking-[0.15em]">
                All formats accepted — auto-converted to embed. Videos are NEVER uploaded; they always stream from YouTube.
            </p>
            {embed && (
                <div className="relative aspect-video w-full mt-4 border border-zinc-800" data-testid="editor-video-preview">
                    <iframe src={embed} title="preview" allowFullScreen className="absolute inset-0 w-full h-full" />
                </div>
            )}
        </Field>
    );
};
